import(/* webpackMode: "eager" */ "/tmp/seed/source/web/src/app/(share)/share/l/[list]/add/page.tsx");
